import { makeAutoObservable } from "mobx";

class Payment {
  paymentOrder = null;
  constructor() {
    makeAutoObservable(this);
  }

  getPaymentOrder() {
    return this.paymentOrder;
  }
  setPaymentOrder(order) {
    this.paymentOrder = order;
  }
}

export default new Payment();
